/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZoneModel {
    getFixupPrototypeFunction() { return ZoneModel.fixupPrototype; }

    static newInstance(model: Partial<ZoneModel>): ZoneModel {
        let obj = Object.assign(new ZoneModel(), model);
        ZoneModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZoneModel>): ZoneModel {
        if (!model) return null;
        return ZoneModel.newInstance(<ZoneModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZoneModel) {
        if (!obj) return;

        models.ZoneModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZoneModel): boolean {
        Object.setPrototypeOf(obj, ZoneModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
    }

    /**
     * zone name
     */
    zone: string;

    /**
     * total count details
     */
    count: number;

}
